var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full"},[_c('h1',[_vm._v(_vm._s(_vm.category.name))]),_c('CategoryListItem',{attrs:{"category":_vm.category}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }